import { Utility } from '../utility/utility_controller'

var submenu_controller = {
	i: function () {
		return i()
	},
}

// Keep horizontal desktop submenus in viewport: right-align when parent is last in menu and near the right edge
var EDGE_THRESHOLD = 150

function updateHorizontalSubmenuAlignment() {
	var viewportWidth = document.documentElement.clientWidth || window.innerWidth
	// Desktop: align horizontal desktop submenus to keep them in viewport.
	// Phone: do the same for mobile horizontal submenu overlays.
	var parentSelector = Utility.screenSize === 'phone'
		? '.laynav.mobile-nav.arrangement-horizontal .menu-item-has-children'
		: '.laynav.desktop-nav.arrangement-horizontal .menu-item-has-children'

	jQuery(parentSelector).each(function () {
		var $parent = jQuery(this)
		var $sub = $parent.find('> .sub-menu')
		if (!$sub.length) return
		var isLast = $parent[0].parentNode && $parent[0].parentNode.lastElementChild === $parent[0]
		var parentRect = $parent[0].getBoundingClientRect()
		var nearRightEdge = parentRect.right > viewportWidth - EDGE_THRESHOLD
		if (isLast && nearRightEdge) {
			$sub.addClass('submenu-align-right')
		} else {
			$sub.removeClass('submenu-align-right')
		}
	})
}

var bindSubmenuClicks = function () {
	var mobile_menu_has_desktop_menu_style = false
	// some more behaviour when mobile menu is desktop menu
	if (jQuery('.laynav.mobile-nav').hasClass('mobile-menu-style-style_desktop_menu') || jQuery('.laynav.mobile-nav').hasClass('mobile-menu-style-button_menu_style')) {
		mobile_menu_has_desktop_menu_style = true
	}
	// phone:
	// this menu point should not follow a link when clicked but only toggle showing submenu
	jQuery('.laynav.mobile-nav .menu-item-has-children>a').on('click', function (e) {
		var followParentLink = false

		// we can prevent link click
		if (Utility.screenSize == 'phone') {
			followParentLink = false
		}
		if (Utility.screenSize == 'phone' && (jQuery('.laynav.mobile-nav').hasClass('mobile-menu-style-style_desktop_menu') || jQuery('.laynav.mobile-nav').hasClass('mobile-menu-style-button_menu_style')) && layData.menu_submenu_follow_parent_link_on_click_to_open_submenu == 1) {
			followParentLink = true
		}

		if (followParentLink == false) {
			e.preventDefault()
			e.stopPropagation()
		}

		if (layData.menu_submenu_show_on == 'click' && layData.menu_submenu_keep_open_2) {
			// close other submenus
			jQuery('.show-submenu-desktop').removeClass('show-submenu-desktop')
		}
		if (mobile_menu_has_desktop_menu_style) {
			// close other submenus
			jQuery('.show-submenu-mobile').not(jQuery(this).closest('.menu-item-has-children')).removeClass('show-submenu-mobile')
		}
		jQuery(this).closest('.menu-item-has-children').toggleClass('show-submenu-mobile')
		if (mobile_menu_has_desktop_menu_style) {
			if (jQuery(this).closest('.menu-item-has-children').hasClass('show-submenu-mobile')) {
				jQuery(window).one('click', function () {
					jQuery('.show-submenu-mobile').removeClass('show-submenu-mobile')
				})
			}
		}
	})
	// ipad and desktop:
	// also on ipads for the normal menu, or when show submenu is set to show on click
	if (Utility.isTouchDevice || layData.menu_submenu_show_on == 'click') {
		jQuery('.laynav.desktop-nav .menu-item-has-children>a').on('click', function (e) {
			var followParentLink = false

			// we can prevent link click
			if (layData.menu_submenu_follow_parent_link_on_click_to_open_submenu == 1) {
				followParentLink = true
			}
			if (Utility.screenSize == 'phone') {
				followParentLink = false
			}
			if (Utility.screenSize == 'phone' && (jQuery('.laynav.mobile-nav').hasClass('mobile-menu-style-style_desktop_menu') || jQuery('.laynav.mobile-nav').hasClass('mobile-menu-style-button_menu_style')) && layData.menu_submenu_follow_parent_link_on_click_to_open_submenu == 1) {
				followParentLink = true
			}

			if (followParentLink == false) {
				e.preventDefault()
				e.stopPropagation()
			}

			var $el = jQuery(this).closest('.menu-item-has-children')
			// close other submenus
			jQuery('.show-submenu-desktop').not($el).removeClass('show-submenu-desktop')

			if (layData.menu_submenu_show_on == 'click' && layData.menu_submenu_keep_open_2 != '1') {
				// close opened submenu on click of its parent menu item, should only be possible if menu_submenu_keep_open_2 == 0
				$el.toggleClass('show-submenu-desktop')
			} else {
				$el.addClass('show-submenu-desktop')
			}
			if ($el.hasClass('show-submenu-desktop')) {
				bindClickToClose()
			}
		})

		if (layData.menu_submenu_show_on == 'click' && layData.menu_submenu_keep_open_2) {
			jQuery(document).on('click', '.laynav>ul>li:not(.menu-item-has-children)>a', function (e) {
				jQuery('.show-submenu-desktop').removeClass('show-submenu-desktop')
			})
		}
	}
}

var bindClickToClose = function () {
	if (layData.menu_submenu_show_on == 'click' && layData.menu_submenu_keep_open_2) {
		// never close a submenu, until another submenu is opened!
		return
	}
	jQuery(window).one('click', function (e) {
		if (layData.menu_submenu_keep_open == true) {
			// if link that is clicked is in opened submenu, dont close it but just bind click to close again
			if (jQuery(e.target).closest('.show-submenu-desktop').length == 1) {
				bindClickToClose()
			} else {
				jQuery('.show-submenu-desktop').removeClass('show-submenu-desktop')
			}
		} else {
			jQuery('.show-submenu-desktop').removeClass('show-submenu-desktop')
		}
	})
}

var i = function () {
	bindSubmenuClicks()
	updateHorizontalSubmenuAlignment()
	jQuery(window).on('resize', updateHorizontalSubmenuAlignment)
}

export default submenu_controller
